<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
export default {
  components: {},
  data() {
    return {
      mobile: null,
      smsCode: null,

      sec: 0, //倒计时
    };
  },

  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
    //发送验证码
    sendMsgCode() {
      this.$toast.clear();
      if (this.$glf.isEmpty(this.mobile)) {
        this.$toast("请输入手机号");
        return false;
      }
      if(!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.mobile)){
        this.$toast('手机号码格式不正确');
        return false;
      }
      this.$toast.loading({
        message: "发送中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      this.$api.sms({ mobile: this.mobile.trim() }).then((res) => {
        this.$toast("手机号验证码发送成功");
        //开始倒计时
        this.sec = 59;
        let t = setInterval(() => {
          this.sec -= 1;
          if (this.sec <= 0) {
            clearInterval(t);
          }
        }, 1000);
      });
    },
    //修改手机号
    editMobile(){
      if (this.$glf.isEmpty(this.mobile)) {
        this.$toast("请输入手机号");
        return false;
      }
      if(!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.mobile)){
        this.$toast('手机号码格式不正确');
        return false;
      }
      if (this.$glf.isEmpty(this.smsCode)) {
        this.$toast("请输入验证码");
        return false;
      }
      this.$toast.loading({
        message: "处理中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      var params = {
        mobile: this.mobile.trim(),
        smsCode: this.smsCode.trim(),
      };
      this.$api.updateMobile(params).then(res=>{
        this.$toast('修改成功');
        this.mobile = null;
        this.smsCode = null;
        this.$store.dispatch('refreshUser');
        this.$router.back();
      })
    },


    //退出登陆
    logout(){
      this.$store.commit('logout');
      this.$toast('退出登陆成功');
      this.$router.back();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mine/setting/index.vue